import { AppRegistry } from 'react-native';
import App from './App';
import { registerServiceWorker } from './src/platform/pwa';
import './src/assets/fonts/fonts.css';

AppRegistry.registerComponent('Chefi', () => App);
AppRegistry.runApplication('Chefi', { rootTag: document.getElementById('root') });
registerServiceWorker();
